module.exports = __webpack_public_path__ + "img/nellilogo.f791c706.png";